export function intersections<NativeType>(...sets: NativeType[][]): NativeType[] {
  return sets.reduce((acc, next) => {
    return acc.filter(value => next.includes(value))
  })
}
